import axios from "axios";

import {
    DataProviderClient,
    IDataProviderClient,
    ITenantManagementClient,
    TenantManagementClient,
    IUsersClient,
    UsersClient
} from "../api/clients.api";
import {
    IAdminAuthClient,
    AdminAuthClient
} from "../api/auth_clients.api";
import {ApiClientConfig} from "app/modules/common/api/ApiClientConfig";

const hostName = window.location.hostname;
export const apiBaseUrl = hostName == 'localhost' ? 'http://localhost:8080' : 'https://' + hostName;

export class AdminApiClients {
    tenantManagementClient: ITenantManagementClient = null;
    dataProviderClient: IDataProviderClient = null;
    usersClient: IUsersClient = null;
    adminAuthClient: IAdminAuthClient = null;

    constructor(configuration: ApiClientConfig) {
        let axiosInstance = axios.create({
            baseURL: apiBaseUrl,
            headers: {
                'Content-Type': 'application/json'
            },
            validateStatus: (status) => {
                return status >= 200 && status < 500
            }
        });

        axiosInstance.defaults.withCredentials = true;

        this.tenantManagementClient = new TenantManagementClient(configuration, apiBaseUrl, axiosInstance);
        this.dataProviderClient = new DataProviderClient(configuration, apiBaseUrl, axiosInstance);
        this.usersClient = new UsersClient(configuration, apiBaseUrl, axiosInstance);
        this.adminAuthClient = new AdminAuthClient(configuration, apiBaseUrl, axiosInstance);

        axiosInstance.interceptors.response.use((response) => {
            if(response?.status == 401) {
                window.location.href = "/admin/accessDenied";
            }

            /*if(response?.status == 302) {
                window.location.href = response.location;
            }*/

            return response;
        }, (error) => { });
    }
}



